import clsx from 'clsx'
import {FC} from 'react'
import {useIsOnPremises} from '../../auth/core/useOnPremises'
import {hidesPayments} from '../../install-app/core/androidApp'
import {fa} from '../core/serviceApi'
import './ServiceBadge.scss'

export const SERVICE_BADGE_TITLE = 'سرویس ویژه (ارزش‌افزوده): ممکن است تعرفه داشته باشد و از کیف پول کسب‌وکار پرداخت شود.'

/**
 * The mark of a value-added service («سرویس ویژه», user request 2026-10-15): a gem beside its name wherever the
 * service is offered, so a business knows before using it that it may have a tariff. An on-premises install has no
 * value-added services, so no mark either.
 */
export const ServiceBadge: FC<{
  compact?: boolean
  /** Inside a control whose name already says it (a button): hidden from screen readers. */
  decorative?: boolean
  className?: string
  title?: string
}> = ({compact = false, decorative = false, className, title = SERVICE_BADGE_TITLE}) => {
  const onPremises = useIsOnPremises()
  if (onPremises || hidesPayments()) return null
  return (
    <span
      className={clsx('svc-badge', {'svc-badge--compact': compact}, className)}
      title={title}
      aria-hidden={decorative || undefined}
    >
      <i className='las la-gem' aria-hidden='true'></i>
      {compact ? <span className='visually-hidden'>سرویس ویژه</span> : <span>سرویس ویژه</span>}
    </span>
  )
}

/** A price with the offer's struck-through price before it, when there is one: «~~۸۰۰٬۰۰۰~~ ۵۰۰٬۰۰۰ ریال». */
export const OfferPrice: FC<{amount: number; listAmount?: number | null; suffix?: string; className?: string}> = ({
  amount,
  listAmount,
  suffix = 'ریال',
  className,
}) => (
  <span className={clsx('svc-price', className)}>
    {listAmount && listAmount > amount ? (
      <>
        <s className='svc-price__list' aria-label={`قیمت قبل از تخفیف ${fa(listAmount)} ${suffix}`}>
          {fa(listAmount)}
        </s>{' '}
        <strong className='svc-price__now'>{fa(amount)}</strong>
        <span className='svc-price__off'>{fa(Math.round(((listAmount - amount) / listAmount) * 100))}٪ تخفیف</span>
      </>
    ) : (
      <strong className='svc-price__now'>{fa(amount)}</strong>
    )}{' '}
    {suffix}
  </span>
)
